import React, { useEffect } from "react";
import { Form, Input, Button, Select, message } from "antd";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import AuthService from "../../services/AuthService";
import Message from "../Message/Message";
import LocalStorageService from "../../services/LocalStorageService";
import { fetchTenants } from "../../store/slices/tenants";
import { checkIsLoaded, featuresToggle, getSelectOptions } from "../../lib/utils";
import Logo from "../Logo/Logo";
import { hasLocalAccess } from "../../lib/configs";
import { useAppSelector } from "../..";
import { AccessToken } from "../../lib/types/AccessToken";

export default function LoginPage() {
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(fetchTenants());
  }, [dispatch]);

  const { tenants, tenantsLoading } = useAppSelector((state) => state.tenants);

  const tenantsFiltered: { id: number }[] = tenants.filter(({ id }) => id > 0);

  useEffect(() => {
    if (tenantsFiltered && tenantsFiltered.length === 1) {
      LocalStorageService.setTenant({ option: tenantsFiltered[0] });
      form.setFieldsValue({ tenant: tenantsFiltered[0].id });
    }
  }, [form, tenantsFiltered]);

  const handleChangeTenant = (value, item) => {
    if (item) {
      LocalStorageService.setTenant(item);
    }
  };

  const handleSubmit = (values) => {
    AuthService.login(values)
      .then((response) => {
        const token = jwtDecode<AccessToken>(response.data.access_token);
        const hasNotAuthorities: boolean = featuresToggle({
          value: !token.authorities,
          alternativeValue: false,
          condition: hasLocalAccess("feature.roles"),
        });
        const hasNotSystemWp: boolean = featuresToggle({
          value: !token.authorities?.includes("SYSTEM.WP"),
          alternativeValue: false,
          condition: hasLocalAccess("feature.roles"),
        });

        const hasSystemWpAndHasNotAuthorities = !hasNotSystemWp && token.authorities?.length === 1;

        // 1. Если у пользователя нет привелегии SYSTEM.WP, но вдруг есть другие привелегии
        // 2. Если у пользователя есть привелегии SYSTEM.WP и у него нет привелегий Биллинга (т.е. у него есть только привелегия SYSTEM.WP)
        // 3. Если у пользователя нет привелегий Биллинга вообще
        if (hasNotSystemWp || hasSystemWpAndHasNotAuthorities || hasNotAuthorities) {
          message.destroy();
          message.error("Ошибка авторизации");
        } else {
          LocalStorageService.setToken(response.data);
          window.location.reload();
        }
      })
      .catch((error) => {
        const errorDescription = error?.response?.data?.error_description;

        if (errorDescription) {
          // Проверяем, содержит ли описание хотя бы одну английскую букву
          const containsEnglishLetter = /[a-zA-Z]/.test(errorDescription);
          if (containsEnglishLetter) {
            Message("Ошибка авторизации");
          } else {
            Message(errorDescription);
          }
        } else {
          Message("Ошибка авторизации");
        }
      });
  };

  return (
    <>
      {checkIsLoaded(tenantsLoading) && (
        <div
          style={{
            height: "75vh",
            width: "620px",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "0 auto",
          }}
        >
          <Logo />
          <h1 style={{ marginTop: "50px" }}>Авторизация</h1>
          <Form
            form={form}
            style={{ marginTop: "51px" }}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={handleSubmit}
          >
            <Form.Item
              name="tenant"
              hidden={tenantsFiltered.length < 2}
              rules={[{ required: true, message: "Выберите сегмент" }]}
            >
              <Select
                placeholder="Сегмент"
                allowClear
                onChange={handleChangeTenant}
                options={getSelectOptions({
                  list: tenantsFiltered,
                })}
              />
            </Form.Item>
            <Form.Item name="login" rules={[{ required: true, message: "Введите логин" }]}>
              <Input placeholder="Логин" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: "Введите пароль" }]}>
              <Input.Password placeholder="Пароль" />
            </Form.Item>
            <Form.Item>
              <Button
                style={{
                  width: "620px",
                  background: "#00aaff",
                }}
                type="primary"
                htmlType="submit"
              >
                Войти
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
    </>
  );
}
